import { createApiSlice } from "@common";
import {
  CRUD_INTEGRATION_CHECK,
  GET_INTEGRATION_CHECK_BY_SERVICE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addIntegrationCheck",
    method: "post",
    url: CRUD_INTEGRATION_CHECK,
    stateKey: "message",
  },
  {
    name: "getIntegrationCheckByService",
    method: "get",
    url: GET_INTEGRATION_CHECK_BY_SERVICE,
    stateKey: "data",
  },
  {
    name: "updateIntegrationCheck",
    method: "put",
    url: CRUD_INTEGRATION_CHECK,
    stateKey: "message",
  },
  {
    name: "deleteIntegrationCheck",
    method: "delete",
    url: CRUD_INTEGRATION_CHECK,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "integrationCheck",
  apiConfig,
  customReducers,
);
const integrationCheckSlice = slice;
// Export the slice's reducer
export default integrationCheckSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addIntegrationCheck,
  getIntegrationCheckByService,
  updateIntegrationCheck,
  deleteIntegrationCheck,
} = thunks;

// Destructure and export actions
export const { rowSelect } =
  actions;
